module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/6_5452b78e7eea3e277a9b645c8d8a4537.png";